<p-dialog
  [modal]="true"
  [visible]="true"
  (visibleChange)="matDialogRef.close()"
  [breakpoints]="{ '1199px': '75vw', '575px': '90vw' }"
  [style]="{ width: '50rem' }"
  [resizable]="true"
  [maximizable]="true"
  [maximizable]="true"
  [closable]="true"
>
  <ng-template pTemplate="header">
    <div class="flex align-items-center">
      <i
        [class]="
          'mb-1 text-primary pi pi-fw ' +
          (dialogData.data.cpf ? 'pi-user' : 'pi-building')
        "
        style="font-size: 20px;"
      ></i>
      &nbsp;
      <span class="fs-large font-light">
        Consulta de dados pessoa
        {{ dialogData.data.cpf ? 'física (PF)' : 'jurídica (PJ)' }}
      </span>
    </div>
  </ng-template>
  <div
    class="flex align-items-center flex-column justify-content-center width-100"
    [ngStyle]="{ height: '500px' }"
    *ngIf="searchingCep"
  >
    <p-progressSpinner></p-progressSpinner>
    <span class="font-light fs-normal">Buscando CEP...</span>
  </div>
  <div *ngIf="!searchingCep">
    <info-predictus-pf
      *ngIf="dialogData.data.cpf"
      [pessoaFisica]="pessoaFisica"
    ></info-predictus-pf>
    <info-predictus-pj
      *ngIf="!dialogData.data.cpf"
      [pessoaJuridica]="pessoaJuridica"
    ></info-predictus-pj>
  </div>
  <ng-template pTemplate="footer">
    <div class="flex align-items-center justify-content-center width-100 mb-3">
      <button
        pButton
        pRipple
        label="Usar dados para cadastro"
        icon="pi pi-fw pi-copy"
        severity="primary"
        rounded
        outlined
        (click)="usarDados()"
        iconPos="right"
      ></button>
    </div>
  </ng-template>
</p-dialog>
